import { FreemiumSignupScreen } from "@/features/auth/screens/FreemiumSignupScreen";
import { createFileRoute } from "@tanstack/react-router";

const FreemiumSignup = () => {
    const { email } = Route.useSearch();
    return <FreemiumSignupScreen email={email} />;
};

export const Route = createFileRoute("/_auth/_public/signup/trial")({
    component: FreemiumSignup,
    validateSearch: (search: Record<string, unknown>) => ({
        email: typeof search.email === "string" ? search.email : undefined,
    }),
});

export default FreemiumSignup;
